<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Ae5G2G/images/9781429929691.jpg?1726444428029" alt="This image is the cover for the book Good Psychologist"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Good Psychologist
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"Noam Shpancer portrays the oft-hidden world of psychotherapy with unparalleled authenticity, compassion, and wit . . . An astonishing debut."—Jonathan Kellerman</b><br/><br/>Noam Shpancer's stunning debut novel opens as a psychologist reluctantly takes on a new client—an exotic dancer whose severe anxiety is keeping her from the stage. The psychologist, a solitary professional who also teaches a lively night class, helps the client confront her fears. But as treatment unfolds, her struggles and secrets begin to radiate onto his life, upsetting the precarious balance in his unresolved relationship with Nina, a married former colleague with whom he has a child—a child he has never met. As the shell of his detachment begins to crack, he suddenly finds himself too deeply involved, the boundary lines between professional and personal, between help and harm, blurring dangerously. <br/><br/>With its wonderfully distinctive narrative voice, rich with humor and humanity, <i>The Good Psychologist</i> leads the reader on a journey into the heart of the therapy process and beyond, examining some of the fundamental questions of the soul: to move or be still; to defy or obey; to let go or hold on.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Noam Shpancer
      </h2>
      
      <p class="authorDescription body article"><P><B>Noam Shpancer</B> was born and raised on an Israeli kibbutz. He received his Ph.D. in clinical psychology from Purdue University. Currently, he is professor of psychology at Otterbein College and a licensed practicing clinical psychologist. He lives in Columbus, Ohio.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1dc53d83